import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultSearchDialogComponent } from './default-search-dialog/default-search-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageBoxDialogComponent } from './message-box-dialog/message-box-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        DefaultSearchDialogComponent,
        MessageBoxDialogComponent
    ],
    exports: []
})
export class DialogsModule { }
